<template>
    <notice>
        <div class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg">
            <loading :showLoading="form.processing" />
            <div :class="{ 'opacity-50': form.processing, 'opacity-100': !form.processing }">
                <p class="mb-4 text-lg font-medium">Edit Notice</p>
                <form @submit.prevent="submitForm">
                    <div class="grid grid-cols-8 gap-4 mb-4">
                        <div class="col-span-8 sm:col-span-8">
                            <breeze-label :value="'Title'" :required="true" />
                            <breeze-input required v-model="form.title" class="w-full" />
                            <breeze-input-error :message="form.errors ? form.errors.title : ''" />
                        </div>
                        <div class="col-span-8 sm:col-span-8">
                            <breeze-label :value="'Notice'" :required="true" class="mb-1" />
                            <vue-editor v-model="form.notice"></vue-editor>
                            <breeze-input-error :message="form.errors ? form.errors.notice : ''" />
                        </div>
                        <div>
                            <breeze-label :value="'Branch'" />
                            <input-checkbox required type="radio" class="rounded-full" name="type" v-model="form.type"
                                value="branch" :checked="form.type == 'branch'" />
                        </div>
                        <div>
                            <breeze-label :value="'Teacher'" />
                            <input-checkbox required type="radio" class="rounded-full" name="type" v-model="form.type"
                                value="teacher" :checked="form.type == 'teacher'" />
                        </div>
                        <div>
                            <breeze-label :value="'Student'" />
                            <breeze-checkbox required type="radio" class="rounded-full" name="type" v-model="form.type"
                                value="student" :checked="form.type == 'student'" />
                        </div>
                        <div class="col-span-2" v-if="form.type != 'branch'">


                            <FormMultiselect label="Select Branch" :options="branches" track-key="id" label-key="title"
                                :object="true" v-model="form.branch" :placeholder="'Select Branch'"
                                :error="form.errors.branch" />

                        </div>
                        <div class="col-span-3" v-if="form.type != 'branch' && form.branch">


                            <FormMultiselect label="Select Course Year" :options="allCourseYear" track-key="id"
                                label-key="title" :object="true" v-model="form.courseyear"
                                :placeholder="'Select Course Year'" :error="form.errors.courseyear" />
                        </div>
                        <div class="col-span-2" v-if="form.type != 'branch' && form.branch && form.courseyear">

                            <FormMultiselect label="Select Batch" :options="allBatches" track-key="id" label-key="title"
                                :object="true" v-model="form.batch" :placeholder="'Select Batch'"
                                :error="form.errors.batch" />
                        </div>
                        <div class="col-span-2">
                            <breeze-label :value="'Due Date'" :required="true" />
                            <breeze-input type="date" required v-model="form.due_date" class="w-full" />
                            <breeze-input-error :message="form.errors ? form.errors.due_date : ''" />
                        </div>
                        <div>
                            <breeze-label :value="'Status'" />
                            <breeze-checkbox required v-model="form.status" :checked="form.status" />
                            <breeze-input-error :message="form.errors ? form.errors.status : ''" />
                        </div>
                    </div>
                    <button-link :href="route('notice.branch.list')"
                        class="mr-4 bg-red-500 hover:bg-red-400">Cancel</button-link>
                    <breeze-button :disabled="form.processing">Save</breeze-button>
                    <exception />
                </form>
            </div>
        </div>
    </notice>
</template>

<script>
import Notice from '@/Pages/Notice/Notice'
import BreezeInput from '@/Components/Input'
import BreezeLabel from '@/Components/Label'
import BreezeCheckbox from '@/Components/Checkbox'
import InputCheckbox from '@/Components/InputCheckbox'
import SelectList from '@/Components/SelectList'
import BreezeButton from '@/Components/Button'
import BreezeInputError from '@/Components/InputError'
import ButtonLink from '@/Components/ButtonLink'
import Exception from '@/Components/Exception'
import { useForm } from '@inertiajs/inertia-vue3'
import Loading from '@/Components/Loading'
import { VueEditor } from "vue3-editor";
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";

export default {
    components: {
        FormMultiselect,
        Notice,
        ButtonLink,
        BreezeInput,
        BreezeLabel,
        BreezeInputError,
        BreezeButton,
        Exception,
        SelectList,
        Loading,
        BreezeCheckbox,
        InputCheckbox,
        VueEditor
    },
    props: ['branches', 'notice', 'courseyears', 'batches'],
    data() {
        return {
            form: useForm({
                '_method': 'PUT',
                title: this.notice.title,
                notice: this.notice.notice,
                due_date: this.notice.due_date,
                type: this.notice.type,
                branch: this.notice.branch,
                courseyear: this.notice.courseyear,
                batch: this.notice.batch,
                status: this.notice.status,
            }),
        }
    },
    methods: {
        submitForm() {
            this.form.post(route('notice.update', this.notice.id), {
                preserveScroll: true,
                onSuccess: () => this.form.reset(),
            });
        },
    },
    computed: {
        allCourseYear() {
            var courseyears = [];
            this.courseyears.forEach((courseyear) => {
                courseyears.push({ title: courseyear.title + ' - ' + courseyear.course.title + ' - ' + courseyear.duration.start_month, id: courseyear.id });
            })
            return courseyears;
        },
        allBatches() {
            var batches = [];
            this.batches.forEach((batch) => {
                if (batch.course_year_id == this.form.courseyear.id) {
                    batches.push({ title: batch.title, id: batch.id });
                }
            })
            return batches;
        },
    }
}
</script>
<style>
.ck-editor__editable {
    height: 400px;
}

.ck-file-dialog-button {
    display: none;
}
</style>
